import { useEffect } from "react";
import { createPortal } from "react-dom";
import { FaTimes } from "react-icons/fa";

import styles from "./Modal.module.css";

const Modal = ({

    open,

    title,

    children,

    size = "md",

    closeOnBackdrop = true,

    onClose,

}) => {

    useEffect(() => {

        if (!open) return;

        const handleKeyDown = (e) => {

            if (e.key === "Escape") {

                onClose?.();

            }

        };

        document.addEventListener(

            "keydown",

            handleKeyDown

        );

        document.body.style.overflow = "hidden";

        return () => {

            document.removeEventListener(

                "keydown",

                handleKeyDown

            );

            document.body.style.overflow = "";

        };

    }, [

        open,

        onClose,

    ]);

    if (!open) {

        return null;

    }

    return createPortal(

        <div

            className={styles.backdrop}

            onClick={() => {

                if (closeOnBackdrop) {

                    onClose?.();

                }

            }}

        >

            <div

                className={`${styles.modal} ${styles[size]}`}

                onClick={(e) =>

                    e.stopPropagation()

                }

            >

                <div className={styles.header}>

                    <h3>

                        {title}

                    </h3>

                    <button

                        type="button"

                        className={styles.closeButton}

                        onClick={onClose}

                    >

                        <FaTimes />

                    </button>

                </div>

                <div className={styles.body}>

                    {children}

                </div>

            </div>

        </div>,

        document.body

    );

};

export default Modal;